import './SearchFrameworkIndicator.css';

import React, { useContext } from 'react';
import ElementsCarousel from '../../../b2b-common/ElementsCarousel';
import FrameworkCard from '../../../b2b-frameworks/components/FrameworkCard';
import { SelectIndicatorContext } from '../../pages/AreaIndicatorEditPage';
import FrameworkSearchForm from '../../../b2b-frameworks/components/FrameworkSearchForm';
import B2BElementsExplorer from '../../../b2b-common/B2BElementsExplorer';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import { getFrameworkSuitte } from '../../../b2b-frameworks/components/helper';
import SelectableIndicatorCard from '../../../b2b-indicators/components/SelectableIndicatorCard';

const SearchFrameworkIndicator = ({ onSelectedFrameworkIndicator }) => {

    const { t } = useB2BTranslation('b2b-plans');
    const { frameworkIndicators, setFrameworkIndicators } = useContext(SelectIndicatorContext);

    const handleSelectedFramework = (framework) => {
        setFrameworkIndicators(prevState => ({
            ...prevState,
            selectedFramework: framework.props.framework,
            currentPage: 1,
            refresh: true
        }));
    }

    const handlePageChange = (event, value) => {
        setFrameworkIndicators(prevState => ({
            ...prevState,
            currentPage: value,
            refresh: true
        }));
    };

    const handleSelectedFrameworkIndicator = (indicator) => {
        // console.log('handleSelectedFrameworkIndicator: ', indicator);
        onSelectedFrameworkIndicator && onSelectedFrameworkIndicator(indicator);
    }

    return (
        <div className='search-framework-indicator'>
            <ElementsCarousel
                elements={frameworkIndicators.all.map(framework =>
                    <FrameworkCard key={`${framework.frameworkMicroserviceAcronym}_${framework.frameworkId}`} framework={framework} />
                )}
                onElementSelect={handleSelectedFramework}
            />
            {(frameworkIndicators.selectedFramework) ? (
                <>
                    <div className='search-framework-indicator-selected-framework'>
                        <h3>{frameworkIndicators.selectedFramework.frameworkName}</h3>
                        <p>{frameworkIndicators.selectedFramework.frameworkDescription}</p>
                    </div>
                    <div className='search-framework-indicator-selected-framework-indicators-explorer'>
                        <FrameworkSearchForm
                            frameworkSuite={getFrameworkSuitte(frameworkIndicators.selectedFramework)}
                            title={t('Framework indicators search form for: ') + frameworkIndicators.selectedFramework.frameworkName}
                            framework={frameworkIndicators.selectedFramework}
                            currentPage={frameworkIndicators.currentPage}
                            setCurrentPage={(page) => setFrameworkIndicators(prevState => ({ ...prevState, currentPage: page }))}
                            refresh={frameworkIndicators.refresh}
                            setRefresh={(refresh) => setFrameworkIndicators(prevState => ({ ...prevState, refresh }))}
                            isSearching={frameworkIndicators.isSearching}
                            setIsSearching={(isSearching) => setFrameworkIndicators(prevState => ({ ...prevState, isSearching }))}
                            setIndicatorsData={(data) => setFrameworkIndicators(prevState => ({ ...prevState, data }))}
                            setPagesCount={(count) => setFrameworkIndicators(prevState => ({ ...prevState, pagesCount: count }))}
                            className={'b2b-search-form-vue-inspired-01'}
                        />
                        <B2BElementsExplorer
                            title={t('Selected framework indicators results')}
                            isSearching={frameworkIndicators.isSearching}
                            elementsData={frameworkIndicators.data}
                            pagesCount={frameworkIndicators.pagesCount}
                            currentPage={frameworkIndicators.currentPage}
                            handlePageChange={handlePageChange}
                            pageNumberLoading={frameworkIndicators.pageNumberLoading}
                            className="custom-indicators-explorer"
                            ElementComponent={SelectableIndicatorCard}
                            elementComponentPropName="indicator"
                            otherComponentProps={{
                                className: 'custom-indicator-card b2b-indicator-theme-light-01',
                            }}
                            elementComponentHandlers={{
                                onSelect: handleSelectedFrameworkIndicator,
                            }}
                        />
                    </div>
                </>
            ) : null}
        </div>
    );
};

export default SearchFrameworkIndicator;